import React from "react";
import AntdCol from 'antd/lib/col';

export default (props)=> <AntdCol {...props} />;




// WEBPACK FOOTER //
// ./src/components/col/index.tsx